import axios from "axios";
import { authorizedHeader } from "./authorization";
import {
  vehicleTestListUrl,
  vehicleTestHBStartApiUrl,
  vehicleTestHBResultApiUrl,
  vehicleDataApiUrl,
} from "components/Common/endpoints";

export const heartBeatStart = async (vIdVal) => {
  const response = await axios({
    method: "GET",
    url: vehicleTestHBStartApiUrl,
    params: {
      vIdVal,
    },
    headers: authorizedHeader(),
    json: true,
  });
  return response?.data;
};

export const getHeartBeatHistory = async (vIdVal, page, pageSize = 4) => {
  const response = await axios({
    method: "GET",
    url: vehicleTestListUrl,
    params: {
      vIdVal,
      type: "CONNECTIVITY",
      page: page,
      size: pageSize,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getHeartBeatResult = async (testId) => {
  const response = await axios({
    method: "GET",
    url: vehicleTestHBResultApiUrl + "/" + testId,
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getEOLGraphData = async (vIdVal, testId, field, dataTable) => {
  const response = await axios({
    method: "POST",
    url: vehicleDataApiUrl,
    params: {
      vIdVal,
      testId: testId,
      dataTable,
      showErrors: false,
    },
    data: {
      field: field?.length ? [field] : field,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getEolGraphLiveData = async (vIdVal, field, dataTable) => {
  const response = await axios({
    method: "POST",
    url: vehicleDataApiUrl,
    params: {
      vIdVal,
      startTime: Date.now() - 2 * 60 * 1000, // 10 secs before now
      endTime: Date.now(),
      dataTable,
      showErrors: false,
    },
    data: {
      field: field?.length ? [field] : field,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};

export const getEOLData = async (
  vIdVal,
  testId,
  dataTable,
  field,
  showErrors = false
) => {
  const response = await axios({
    method: "POST",
    url: vehicleDataApiUrl,
    params: {
      vIdVal,
      testId,
      dataTable,
      showErrors,
    },
    data: {
      field: field?.length ? [field] : field,
    },
    headers: authorizedHeader(),
  });
  return response?.data;
};
